import React from 'react';

const icon = (props) => (<i className={props.classType} style={{color: props.iconColor}}></i>);

export default icon;
